<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title mb-0">
                <i class="fa fa-phone"></i> 3C Plus - Configurações
              </h4>
            </div>
            <div class="card-body">
              <b-tabs content-class="mt-3" v-model="tabIndex">
                <b-tab title="Configuração Principal" :title-link-class="linkClass(0)">
                  <ThreeCPlusConfig />
                </b-tab>
                <b-tab title="Usuários Vinculados" :title-link-class="linkClass(1)">
                  <ThreeCPlusUsers />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import ThreeCPlusConfig from './ThreeCPlusConfig.vue'
import ThreeCPlusUsers from './ThreeCPlusUsers.vue'

export default {
  name: 'ThreeCPlus',
  components: {
    ThreeCPlusConfig,
    ThreeCPlusUsers
  },
  data () {
    return {
      tabIndex: 0
    }
  },
  methods: {
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['text-primary']
      } else {
        return ['text-muted']
      }
    }
  }
}
</script>

  <style scoped>
  .card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
  }

  .nav-tabs .nav-link {
    border: none;
    border-bottom: 2px solid transparent;
  }

  .nav-tabs .nav-link.active {
    border-bottom-color: #007bff;
    background-color: transparent;
  }

  .nav-tabs .nav-link:hover {
    border-bottom-color: #007bff;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/threeCPlus/ThreeCPlus.vue